import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { VehicleTypeEnum } from '@splitsecondconnect/ultramarine-shared';

import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';
import { SingleDropdownComponent } from 'app/shared/components/dropdowns/single-dropdown/single-dropdown.component';
import { InputFieldComponent } from 'app/shared/components/input-field/input-field.component';
import { MoreSectionsComponent } from 'app/shared/components/more-sections/more-sections.component';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { DatetimePickerComponent } from '../../../../../../shared/components/datetime-picker/datetime-picker.component';
import { ToggleNewComponent } from '../../../../../../shared/components/toggle-new/toggle-new.component';
import {
	numberCast,
	toDateString,
} from '../../../../../../shared/functions/sectionCasters.function';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';
import {
	VEHICLE_ALLOCATION_TYPE,
	VEHICLE_ODOMETER_UNIT,
	VEHICLE_STEERING_POSITION,
	VEHICLE_FUEL_TYPE,
} from '../../../translations/vehicles-select-items';

@Component({
	selector: 'app-vehicles-details',
	templateUrl: 'vehicles-details.component.html',
	imports: [
		ReactiveFormsModule,
		InputFieldComponent,
		SingleDropdownComponent,
		SectionWrapperComponent,
		DatetimePickerComponent,
		TranslocoModule,
		ToggleNewComponent,
		MoreSectionsComponent,
	],
})
export class VehiclesDetailsComponent
	extends BaseSectionComponent<VehicleRecordModel>
	implements OnInit
{
	vehicleTypeEnum = VehicleTypeEnum;
	protected _skipCount: number = 0;
	fuelType = VEHICLE_FUEL_TYPE;
	steeringPosition = VEHICLE_STEERING_POSITION;
	allocationType = VEHICLE_ALLOCATION_TYPE;
	odometerUnit = VEHICLE_ODOMETER_UNIT;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			vin: [null],
			engineNumber: [null],
			licensePlate: [null],
			registeredAt: [null],
			allocation: [null],
			deregisteredAt: [null],
			fuelType: [null],
			steeringPosition: [null],
			doors: [null],
			seats: [null],
			hasGpsTracker: [null],
			gpsTrackerUuid: [null],
			odometerUnit: [null],
			isTransferable: [null],
		});
	}

	setHasGpsTracker(event) {
		this.detailsForm.get('hasGpsTracker').setValue(event.detail.checked);
	}

	_mapModelToForm(): void {
		const detailsFormData: any = {
			vin: this.recordData().vin,

			engineNumber: this.recordData().engineNumber,
			allocation: this.recordData().allocation,
			licensePlate: this.recordData().licensePlate,
			registeredAt: toDateString(this.recordData().registeredAt),
			deregisteredAt: toDateString(this.recordData().deregisteredAt),
			fuelType: this.recordData().fuelType,
			steeringPosition: this.recordData().steeringPosition,
			doors: this.recordData().doors,
			seats: this.recordData().seats,
			hasGpsTracker: this.recordData().hasGpsTracker,
			gpsTrackerUuid: this.recordData().gpsTrackerUuid,
			odometerUnit: this.recordData().odometerUnit,
			isTransferable: this.recordData().isTransferable,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	_mapFormToModel(): Partial<VehicleRecordModel> {
		return {
			vin: this.detailsForm.value.vin,

			engineNumber: this.detailsForm.value.engineNumber,
			licensePlate: this.detailsForm.value.licensePlate,
			registeredAt: this.detailsForm.value.registeredAt,
			allocation: this.detailsForm.value.allocation,
			deregisteredAt: this.detailsForm.value.deregisteredAt,
			fuelType: this.detailsForm.value.fuelType,

			steeringPosition: this.detailsForm.value.steeringPosition,
			doors: numberCast(this.detailsForm.value.doors),
			seats: numberCast(this.detailsForm.value.seats),
			hasGpsTracker: this.detailsForm.value.hasGpsTracker,
			gpsTrackerUuid: this.detailsForm.value.gpsTrackerUuid,
			odometerUnit: this.detailsForm.value.odometerUnit,
			isTransferable: this.detailsForm.value.isTransferable,
		};
	}
}
